export const SORTED_MEALS = [
  'BREAKFAST',
  'MIDDLE_MORNING',
  'LUNCH',
  'MIDDLE_AFTERNOON',
  'DINNER',
  'AFTER_DINNER',
]

export const MEAL_PARTS = [
  'BREAKFAST',
  'LUNCH',
  'DINNER',
  'SNACK',
  'DESSERT',
  'FRUIT',
  'VEGETABLE',
  'SALAD',
  'SOUP',
  'STARTER',
  'SIDE_DISH',
  'BREAD',
  'DRINK',
  'SMOOTHIE',
  'JUICE',
  'CEREAL',
] as const
